import $ from 'jquery';
import _ from 'underscore';
import Numeral from 'numeral';
import Cache from 'root/cache';
import Router from 'root/router';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Modal from 'root/module/modal';
import Model_Survey from 'model/survey';
import UI from 'root/ui';
import View from 'view/base';

export default View.extend({
    className: 'project-overview',

    events: {
        'click'                 : 'openProject',
        'click li.project-info' : 'onViewProjectInfo',
        'click .rename'         : 'onRename',
        'click .manage-domains' : 'onManageDomains',
        'click .manage-members' : 'onManageMembers',
        'click .delete'         : 'onDelete',
        'click .restore'        : 'onRestore',
        'click .archive'        : 'onArchive',
        'click .copy'           : 'onCopy',
        'click .export'         : 'onExport',
        'click .settings'       : 'onOpenSettings',
        'click .project-star'   : 'onProjectStar'
    },

    dom_handlers: {
        openProject: function(e) {
            if ($(e.target).hasClass('stop-propagation') || $(e.target).parents('.stop-propagation').length) {
                return;
            }

            if (this.model.get('is_archived')) {
                Modal.open({
                    title: 'Project archived',
                    content: 'This project is archived. You will need to restore the project to view its feedback.',
                    button: {
                        OK: () => {
                            Modal.close();
                        }
                    }
                });
                return;
            }
            const dashboard_url = '/' + this.model.get('project_key') + '/dashboard/';

            Router.navigate(dashboard_url, {trigger: true});
        },

        onViewProjectInfo: function(e) {
            Modals.viewProjectInfo(this.model.id, 'about');
        },

        onRename: function(e) {
            Modals.editProjectName(this.model.id);
        },

        onManageDomains: function(e) {
            Modals.editProjectDomains(this.model.id);
        },

        onManageMembers: function(e) {
            Modals.manageProjectMembers(this.model.id);
        },

        onDelete: function(e) {
            Modals.deleteProject(this.model.id);
        },

        onRestore: function(e) {
            Modals.restoreProject(this.model.id);
        },

        onArchive: function(e) {
            Modals.archiveProject(this.model.id);
        },

        onCopy: function(e) {
            if (Cache.account.getProjectLimit() <= Cache.project.where({is_archived: false}).length) {
                Modals.unlockFeature('To have more projects in your account, please upgrade your account plan.');
            } else {
                Modals.copyProject(this.model.id);
            }
        },

        onExport: function(e) {
            if (Cache.account.get('is_expired')) {
                Modals.expiredAccount();
                return;
            }

            if (!Cache.account.hasFeature('export_feedback')) {
                Modals.unlockFeature();
                return;

            }

            if (this.model.isSurvey()) {
                var project_overview = Cache.statistics.get('project_count') ? Cache.statistics.get('project_count')[this.model.id] : false;

                if (!project_overview || project_overview.survey.length === 0) {
                    // something went seriously wrong
                    return;
                }

                var survey_id = project_overview.survey[0].id;

                Cache.app.request({
                    action: 'survey_response/export',
                    data: {
                        id: survey_id
                    },
                    success: (response) => {
                        if (response) {
                            UI.success('You will be emailed a CSV when it\'s ready. This may take several minutes.', 10);
                        }
                    }
                });
                return;
            } else {
                Cache.app.request({
                    action: 'feedback/export',
                    data: {
                        id: this.model.id
                    },
                    success: (response) => {
                        if (response) {
                            UI.success('You will be emailed a CSV when it\'s ready. This may take several minutes.', 10);
                        }
                    }
                });
            }
        },

        onProjectStar: function(e) {
            var starred_project_ids = Cache.app.getUserSetting('project_starred');

            if (!starred_project_ids) {
                starred_project_ids = [];
            } else {
                starred_project_ids = starred_project_ids.split(',').map(Number);
            }

            var is_starred = starred_project_ids.indexOf(this.model.id) !== -1;

            if (is_starred) {
                starred_project_ids.splice(starred_project_ids.indexOf(this.model.id), 1);
            } else {
                starred_project_ids.push(this.model.id);
            }

            Cache.app.addUserSetting('project_starred', starred_project_ids.join(','));

            this.$el.find('.project-star').attr('data-starred', is_starred ? 0 : 1);

            // reset cache
            Cache.project.resetSortCache();
        },

        onOpenSettings: function(e) {
            Modals.projectSettings(this.model.id);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
        this.listenTo(Cache.statistics, 'change:project_count', this.render);
    },

    toggle: function(show) {
        if (show) {
            this.$el.removeAttr('data-hidden');
        } else {
            this.$el.attr('data-hidden', 1);
        }
    },

    render: function() {
        var project_overview = Cache.statistics.get('project_count') ? Cache.statistics.get('project_count')[this.model.id] : false;
        var total            = project_overview ? project_overview['count']    : 0;
        var total_resolved   = project_overview ? project_overview['resolved'] : 0;
        var total_unresolved = total - total_resolved > 0 ? total - total_resolved : 0;
        var project_owner    = Cache.user.get(this.model.get('created_by'));
        var project_domains  = Cache.project_domain.where({project_id: this.model.id});
        var domain_max       = 3;
        var domain_options   = '';

        project_domains.forEach((domain, count) => {
            if (count < domain_max) {
                domain_options += '<span class="project-domain">' + domain.escape('domain') + '</span>';
            }
        });

        var now = (new Date()).getTime() / 1000;
        var days_90 = 90 * 24 * 60 * 60;

        var delete_text = '';
        var schedule_text = '';

        // display badge when the project will be deleted in 90 days
        if (this.model.get('delete_time') > 0 && (this.model.get('delete_time') - now) < days_90) {
            var days_diff = Math.ceil((this.model.get('delete_time') - now) / 24 / 60 / 60);

            if (days_diff <= 1) {
                delete_text += ' (to be deleted soon)';
            } else {
                delete_text += ' (to be deleted in ' + days_diff + ' days)';
            }
        }

        var is_starred   = Cache.app.getUserSetting('project_starred') && Cache.app.getUserSetting('project_starred').split(',').map(Number).indexOf(this.model.id) !== -1;
        var status = 'activated';
        var status_text  = 'Activated';

        if (project_overview) {
            if (this.model.get('is_archived')) {
                status = 'deactivated';
            } else if (this.model.isFeedback()) {
                if (project_overview.widget.length && !project_overview.widget[0].is_active) {
                    status = 'deactivated';
                    status_text = 'Deactivated';
                }
            } else {
                if (project_overview.survey.length) {
                    var survey = new Model_Survey(project_overview.survey[0]);
                    status = survey.getStatus();
                    status_text = Util.cap(survey.getStatus());
                    schedule_text = survey.getScheduleText();
                }
            }
        }

        var content = '';

        if (this.model.get('logo')) {
            content += '<div class="project-logo-icon-large" style="background-image:url(' + this.model.escape('logo') + ');"></div>';
        } else {
            content += '<div class="project-type-icon-large" data-val="' + (this.model.isFeedback() ? 'feedback' : 'survey') +'"></div>';
        }

        content += '<div>' +
                       '<div class="project-name flex-start">' +
                           '<span>' + Util.htmlEntities(Util.trim(this.model.get('name'), 50)) + '</span>' +
                           (this.model.get('is_archived') || status === 'deactivated' ? '' :
                           '<span class="status-indicator tooltip" data-status="' + status + '" data-title="' + status_text + '"></span>') +
                       '</div>' +

                       (this.model.get('is_archived') ? '' :
                       '<div class="project-info">' +
                       (this.model.get('project_type') === 'survey' ?
                       Numeral(total).format('0,0') + ' response' + (total === 1 ? '' : 's') :
                       Numeral(total_unresolved).format('0,0') + ' of ' + Numeral(total).format('0,0') + ' unresolved') +
                       '</div>') +

                       '<div class="flex-start flex-wrap">' +
                           (domain_options ?
                           domain_options +
                           (project_domains.length > domain_max ? '<span class="project-domain">& ' + (project_domains.length - domain_max) + ' more</span>' : '') :
                           '<span class="project-domain italic">No project domains</span>') +
                        '</div>' +
                   '</div>';

        content += '<div class="flex-end-top">' +
                       '<div class="flex-c">' +
                           (this.model.get('is_archived') ?
                           '<div class="project-date">' +
                               'Archived on ' + Util.moment(this.model.get('archive_time'), null, null, false) +
                               delete_text +
                           '</div>' : '') +

                           (this.model.isSurvey() && !this.model.get('is_archived') ?
                           '<div class="project-date">' +
                               (schedule_text ?
                                '<div class="schedule-info">' +
                                    '<i class="fa-regular fa-clock margin-right-8"></i><div>' + schedule_text + '</div>' +
                                '</div>' : '') +
                           '</div>' : '') +

                           (Cache.account.hasFeature('portal') && this.model.isFeedback() && !this.model.get('is_archived') && project_overview && project_overview.portal_url ?
                           '<div class="project-portal">' +
                               '<a href="' + project_overview.portal_url + '" class="stop-propagation primary no-underline font-weight-medium" target="portal">Ideas Portal <i class="fa-solid fa-square-arrow-up-right"></i></a>' +
                           '</div>' : '') +

                           (this.model.get('is_archived') ? '' :
                           '<button class="project-star stop-propagation" type="button" data-starred="' + (is_starred ? 1 : 0) + '">' +
                               '<i class="fa-solid fa-star-sharp tooltip" data-title="Starred"></i>' +
                               '<i class="fa-regular fa-star-sharp tooltip" data-title="Not Starred"></i>' +
                           '</button>') +
                           '<div class="project-users">' +
                                (project_owner ?
                                '<div class="user-owner user-img-24 user-solid tooltip" data-title="Created by ' + project_owner.escape('name') + '" style="background-image:url(\'' + project_owner.getAvatar(24) + '\');"></div>' :
                                '<div class="user-owner user-img-24 user-solid tooltip" data-title="' + (this.model.get('created_by') > 0 ? 'Created by deleted user' : 'Created by unknown user') + '" style="background-image:url(\'/image/profile.png\');"></div>') +
                           '</div>' +
                           (Cache.app.isAdmin() ?
                           '<div class="button-dropdown button-dropdown-large" data-append="true">' +
                               '<button type="button" class="ellipsis stop-propagation"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                               '<div>' +
                                   '<ul class="dropdown dropdown-long">' +
                                       (this.model.get('is_archived') ?

                                       (this.model.isSurvey() && !Cache.account.hasFeature('survey') ? '' :
                                       '<li class="restore stop-propagation">Restore</li>') +
                                       '<li class="delete stop-propagation">Delete</li>'

                                       :

                                       '<li class="project-info stop-propagation">Project Info</li>' +
                                       '<li class="separator"></li>' +

                                       '<li class="copy stop-propagation">Duplicate</li>' +
                                       '<li class="archive stop-propagation">Archive</li>' +

                                       '<li class="separator"></li>' +

                                       '<li class="rename stop-propagation">Rename</li>' +
                                       '<li class="manage-domains stop-propagation">Manage Domains</li>' +
                                       '<li class="manage-members stop-propagation">Manage Members</li>' +
                                       (Cache.account.hasFeature('export_feedback') && this.model.get('project_type') !== 'survey' ?
                                       '<li class="export stop-propagation">Export Feedback</li>' : '') +

                                       (Cache.account.hasFeature('export_feedback') && this.model.get('project_type') === 'survey' ?
                                       '<li class="export stop-propagation">Export Responses</li>' : '') +

                                       '<li class="separator"></li>' +
                                       '<li class="settings stop-propagation">Project Settings</li>' +

                                       '<li class="separator"></li>' +
                                       '<li class="delete stop-propagation">Delete</li>') +
                                   '</ul>' +
                                '</div>' +
                           '</div>' : '') +
                       '</div>' +
                   '</div>';

        this.$el.html(content);

        return this;
    }
});